import React from 'react';
import { authController } from '@reedexpo/authorization-component-ui';
import 'regenerator-runtime/runtime';
import { createRoot } from 'react-dom/client';
import ParticipantDirectory from '../../src/js/participant-directory/ParticipantDirectory';
import '../../src/styles/participant-directory.less';
import AlgoliaTokenService from '../../src/js/participant-directory/AlgoliaTokenService';

export default ParticipantDirectory;

if (global.window && global.window.document) {
  const { props, elementId } = window.reactSettingsParticipantDirectory;
  const { baseApiUrl } = props;
  const { interfaceLocale } = props.context;
  const eveId = window.reactSettingsParticipantDirectory.props.context.eventEditionId;
  const showPlanningIds = JSON.parse(localStorage.getItem('showPlanningIds'));
  if (showPlanningIds && showPlanningIds !== null) {
    props.showPlanId = showPlanningIds[eveId];
  }
  const { testVariants, authSettings } = window;
  if (authSettings && authSettings.usePkce) {
    authController.initialize(authSettings);
    authController.addAccessTokenRenewedHandler((token) => {
      console.log('PD session is about to expire.....', token);
      AlgoliaTokenService.renewAlgoliaToken(baseApiUrl, eveId, interfaceLocale);
    });
    authController.login(window.location.href).then((canRender) => {
      if (canRender) {
        renderComponent(props, testVariants, elementId);
      }
    });
  } else {
    renderComponent(props, testVariants, elementId);
  }
}


function renderComponent(props, testVariants, elementId) {
  const container = document.getElementById(elementId);
  const root = createRoot(container);
  root.render(<ParticipantDirectory {...props} testVariants={testVariants} />);
}
